import React, { useEffect } from 'react';
import InputType from './ComponentsTpes/InputType';

const DoorSensor =   ({ fieldsData, componentSourceOptions ,selectedPorts,
     setSelectedPorts, savedData, setSavedData}) => {

    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Door_sensor:{
                    ...prevData.Door_sensor,
                    [key]: value
                }
            }
        })
    }

    return (<InputType
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        source={componentSourceOptions.inputsData}
        selectOptions={selectOptions}
        component_source={savedData.Door_sensor.component_source.value}
        condition={savedData.Door_sensor.condition}
        input={savedData.Door_sensor.input}
        name={savedData.Door_sensor.name}
        fieldsData={fieldsData}
    />)
}

export default DoorSensor;